import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const BuyerIcon: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon sx={{ width: 85, height: 100, fill: 'none', ...sx }} viewBox="0 0 85 100" {...props}>
    <path
      d="M26.3376 40.7883V42.0012C26.3376 44.1459 25.2386 46.1538 23.4182 47.3445H23.4069C23.0141 47.607 22.6062 47.8437 22.1832 48.0544C21.7375 48.28 21.2806 48.476 20.8122 48.6498C19.6603 49.0676 18.4556 49.3265 17.2206 49.4004L15.9667 49.4855L14.1426 49.6038C7.28403 50.0549 1.95508 55.6385 1.95508 62.3684V83.7896"
      stroke="currentColor"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.1533 47.5334C44.0513 47.4705 43.9531 47.4076 43.855 47.3448C42.0308 46.1541 40.9355 44.1425 40.9355 42.0015V41.4136"
      stroke="currentColor"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M39.1412 53.0982C37.5927 53.59 35.8932 53.8636 34.1106 53.8636C28.8496 53.8636 24.3062 51.4897 22.1875 48.0508"
      stroke="currentColor"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.9082 32.8125C23.4537 39.2836 28.4088 43.6802 34.1078 43.6802C39.8069 43.6802 44.762 39.2873 47.3037 32.8125"
      stroke="currentColor"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.9108 32.8127C19.4227 33.249 17.6628 31.7921 16.9754 29.555C16.2881 27.3178 16.9377 25.151 18.4219 24.7109L20.7522 23.8235L20.975 21.786C21.3527 18.3508 23.309 15.2705 26.2888 13.418C31.8557 15.9768 38.1553 16.5796 44.1225 15.1189L44.1792 15.1041C43.59 18.2842 44.7645 21.5272 47.2647 23.6349L47.4762 23.8124L49.7876 24.7109C51.2756 25.1473 51.9214 27.3178 51.2341 29.555C50.5467 31.7921 48.7868 33.2527 47.2987 32.8127"
      stroke="currentColor"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.6017 21.3936C15.5601 19.9182 15.6772 18.2801 16.0624 16.5458C16.2248 15.8173 18.9479 4.40977 28.9599 1.97294C34.304 0.671333 40.4525 2.23918 44.2443 6.18099C45.3207 7.30141 46.0269 8.42553 46.4726 9.25753C46.5519 9.2945 46.6992 9.38325 46.8918 9.51637C50.1058 11.7165 51.9035 15.5141 51.658 19.4485C51.624 19.9921 51.5749 20.617 51.5183 21.2678"
      stroke="currentColor"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M56.9297 50.9941H70.6769"
      stroke="currentColor"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M75.4461 50.9941H79.4116L82.9466 88.7778C83.0184 89.5322 82.4103 90.1867 81.6361 90.1867H45.9725C45.1983 90.1867 44.5903 89.5359 44.662 88.7778L48.197 50.9941H52.0002"
      stroke="currentColor"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M56.9297 55.8275V46.1874C56.9297 42.4712 60.0077 39.4575 63.8033 39.4575C67.5989 39.4575 70.6769 42.4712 70.6769 46.1874V55.8275"
      stroke="currentColor"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.3027 66.0444V83.79"
      stroke="currentColor"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
